import { parseTweet } from 'twitter-text';
import postValidator from '../../utils/postValidator';
import deepmerge from 'deepmerge';
import moment from 'moment';

const state = {
  valid: {
    facebook: {},
    twitter: {},
    instagram: {},
    linkedin: {}
  },
  newPost: {
    timing: {
      date: moment().format('Y-m-d'),
      time: moment().format('H:m:s')
    }
  }
};

// getters
const getters = {};

// actions
const actions = {
  //Validate post for each platform eg. facebook instagram.
  _validate({ commit, state }, post) {
    Object.keys(state.valid).forEach(platform => {
      postValidator
        ._validate(platform, post)
        .then(valid => commit('_updateState', valid));
    });
  },
  _publishPost({ commit, state }) {
    console.log(state);
  }
};

// mutations
const mutations = {
  _updateState(state, data) {
    state.valid[data.platform] = data.state;
  },
  _updateNewPost(state, newPost) {
    const overwriteMerge = (destinationArray, sourceArray, options) =>
      sourceArray;
    state.newPost = deepmerge(state.newPost, newPost, {
      arrayMerge: overwriteMerge
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
